import { jsx as e, jsxs as r } from "react/jsx-runtime";

import { memo as t, useRef as i } from "react";

import { useSyncExternalStore as n } from "use-sync-external-store/shim";

import o from "./model/index.js";

import s from "../../utils/camelCase/index.js";

import a from "../../utils/classNames/index.js";

import d from "../../hooks/useId/index.js";

import l from "@ui-components-3/icons/lib/regular/ChevronDown";

import m from "../DelayedHider/index.js";

const u = {
    s: "p-xxs",
    m: "p-xs",
    l: "p-s",
    xl: "p-m"
}, c = "duration-300", p = ({state: t, idPrefix: i, itemKey: o, item: d, isDisabled: p, renderLabel: f, renderContent: b, unmountCollapsed: x, size: h}) => {
    const g = i + ":" + s(o) + ":", y = g + "button", v = g + "section", C = () => t.activeKey === o, w = n(t.on, C, C), j = p(d), D = !j && w, K = u[h];
    return r("li", {
        children: [ r("button", {
            onClick: j ? void 0 : () => t.setActiveKey(D ? "" : o),
            id: y,
            type: "button",
            "aria-expanded": D ? "true" : "false",
            className: a("gap-s focus-outline-thick-light flex w-full items-center justify-between text-left first-of-type:border-t hover:bg-neutral-200 disabled:bg-neutral-300 aria-expanded:bg-neutral-100", K),
            "aria-controls": v,
            disabled: j,
            children: [ f(d), e(l, {
                "aria-hidden": "true",
                className: a("pointer-events-none shrink-0 transition-transform duration-300", D ? "rotate-180" : "", j ? "" : "text-primary-600")
            }) ]
        }), e("div", {
            role: "region",
            "aria-labelledby": y,
            id: v,
            className: a(`grid border-b transition-[grid-template-rows] ${c}`, D ? "grid-rows-[1fr]" : "grid-rows-[0fr]"),
            children: e(m, {
                delay: 512,
                unmount: x,
                visible: D,
                children: e("div", {
                    className: a(`overflow-hidden transition-[padding] ${c}`, K, D ? "" : "py-0"),
                    children: b(d)
                })
            })
        }) ]
    });
}, f = t((({id: r, items: t, renderLabel: n, renderContent: s, getKey: a, unmountCollapsed: l = !1, isDisabled: m = (() => !1), itemSize: u = "m", ...c}) => {
    const f = d(r), b = i().current ||= new o;
    return e("ul", {
        ...c,
        children: t.map(((r, t) => {
            const i = a(r, t).toString();
            return e(p, {
                state: b,
                idPrefix: f,
                itemKey: i,
                size: u,
                item: r,
                isDisabled: m,
                renderLabel: n,
                renderContent: s,
                unmountCollapsed: l
            }, i);
        }))
    });
}));

export { f as default };
//# sourceMappingURL=index.js.map
